export const BASE_URL: string = process.env.REACT_APP_BASE_URL!;
export const PUSHER_PUBLIC_KEY: string = process.env.REACT_APP_PUSHER_PUBLIC_KEY!;
export const PUSHER_CLUSTER: string = process.env.REACT_APP_PUSHER_CLUSTER!;
